import { useTranslation as e } from "../../i18n.mjs";
import { FieldFeedback as t } from "../field-feedback/index.mjs";
import { FilePreview as n } from "../file-preview/index.mjs";
import { formatBytes as r } from "../../utils/format-bytes.mjs";
import { FilePreviewFromOS as i } from "../file-preview-from-os/index.mjs";
import { ReloadIcon as a } from "../../icons/reload-icon.mjs";
import { FileItemName as o } from "./file-item-name.mjs";
import { Button as s, ProgressBar as c } from "@systemeio/components";
import { twMerge as l } from "tailwind-merge";
import { jsx as u, jsxs as d } from "react/jsx-runtime";
import { AlertTriangleIcon as f, CheckCircleIcon as p, Pencil02Icon as m, XIcon as h } from "@systemeio/icons";
//#region src/components/file-item/file-item-wide.tsx
function g(g) {
	let { t: _ } = e(), v = g.file.name, y = r(g.file.size);
	return /* @__PURE__ */ d("div", {
		className: l("flex w-full cursor-default items-center gap-3 py-3", g.className),
		onClick: (e) => e.stopPropagation(),
		title: v,
		children: [
			/* @__PURE__ */ d("div", {
				className: "group/edit relative size-9.5 shrink-0",
				children: [
					g.file instanceof File ? /* @__PURE__ */ u(i, {
						file: g.file,
						className: "h-full w-full rounded-md"
					}) : /* @__PURE__ */ u(n, {
						src: g.file.thumbnail || g.file.path,
						fileType: g.file.type,
						isThumbnail: !0,
						className: "h-full w-full rounded-md",
						title: v
					}),
					g.showEditButton && !g.error && !g.disabled && g.onEdit && /* @__PURE__ */ u("div", {
						className: "bg-alpha-gray-alpha-gray-25 group-hover/edit:desktop:flex desktop:hidden absolute top-0 left-0 flex h-full w-full cursor-auto items-center justify-center rounded-md backdrop-blur-md",
						children: /* @__PURE__ */ u(s, {
							"aria-label": `${_("file_manager.file_upload.crop_file")}: ${v}`,
							onClick: g.onEdit,
							size: "icon-xs",
							variant: "secondary",
							children: /* @__PURE__ */ u(m, {})
						})
					}),
					g.error && g.onRetryAfterError && /* @__PURE__ */ u("div", {
						className: l("absolute top-0 left-0 flex h-full w-full cursor-auto items-center justify-center rounded-md", g.disabled && "hidden"),
						children: /* @__PURE__ */ u(s, {
							"aria-label": `${_("file_manager.upload")}: ${v}`,
							onClick: g.onRetryAfterError,
							size: "icon-xs",
							variant: "ghost-alpha",
							children: /* @__PURE__ */ u(a, {})
						})
					})
				]
			}),
			/* @__PURE__ */ d("div", {
				className: "flex min-w-0 flex-1 flex-col justify-center gap-1",
				children: [/* @__PURE__ */ d("div", {
					className: "flex items-start justify-between gap-2",
					children: [/* @__PURE__ */ d("div", {
						className: "flex min-w-0 flex-col gap-0.5",
						children: [/* @__PURE__ */ u(o, {
							name: v,
							className: "text-text-secondary text-sm leading-4.5"
						}), !g.error && /* @__PURE__ */ u("div", {
							title: y,
							className: "text-text-tertiary truncate text-sm leading-4.5",
							children: y
						})]
					}), g.isLoading && /* @__PURE__ */ d("span", {
						className: "text-text-tertiary shrink-0 text-sm",
						children: [Math.round(g.progress ?? 0), "%"]
					})]
				}), g.error ? /* @__PURE__ */ u(t, { error: /* @__PURE__ */ d("div", {
					className: "flex items-center gap-1.5",
					children: [/* @__PURE__ */ u(f, {
						"aria-hidden": !0,
						className: "text-icon-error size-3.5 min-w-3.5"
					}), /* @__PURE__ */ u("span", {
						className: "text-left",
						children: g.error
					})]
				}) }) : g.isLoading ? /* @__PURE__ */ u(c, {
					rootProps: { className: "w-full" },
					trackProps: { className: "h-1" },
					value: g.progress ?? 0,
					valueLabel: null
				}) : null]
			}),
			g.isLoaded && /* @__PURE__ */ u(p, {
				"aria-hidden": !0,
				className: "text-icon-success size-6 shrink-0"
			}),
			g.showDeleteButton && g.onDeleteFile && /* @__PURE__ */ u(s, {
				"aria-label": `${_("file_manager.delete")}: ${v}`,
				className: g.isDeleting ? "animate-pulse" : void 0,
				onClick: (e) => {
					e.preventDefault(), e.stopPropagation(), g.onDeleteFile?.();
				},
				disabled: g.disabledDeleteButton || g.disabled,
				size: "icon-md",
				variant: "ghost-gray",
				children: /* @__PURE__ */ u(h, {})
			})
		]
	});
}
//#endregion
export { g as FileItemWide };
